export default {
  props: {
    theme: {
      type: String,
      default: '',
    },
    back: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    hasTitle() {
      return !!this.$slots.title;
    },
    hasSecondary() {
      return !!this.$slots.secondary;
    },
    classModifiers() {
      return {
        'static-page-header': true,
        'static-page-header--secondary': this.hasSecondary,
        [`static-page-header--${this.theme}`]: this.theme,
      };
    },
  },
};




// WEBPACK FOOTER //
// ./src/components/static-page-header/static-page-header.js